module.exports = __webpack_public_path__ + "static/steel-section-results-880x880-19a683214f1e1a067144981351efa35f.png";